import { useGetQualifications } from 'queries';
import { useTranslation } from 'react-i18next';

import { useFixedColumns } from './utils';

import TableCRUDLayout from 'components/shared/CRUD/TableCRUDLayout';

import CreateEditForm from './components/CreateEditForm';

const Qualifications = () => {
  const { t } = useTranslation('common');
  const columns = useFixedColumns();

  const { data, isFetching } = useGetQualifications();

  return (
    <TableCRUDLayout
      FormComponent={CreateEditForm}
      rows={data}
      loading={isFetching}
      columns={columns}
      confirmationTitle={t('adminPortal.deleteQualificationDialog.title')}
      confirmationBody={t('adminPortal.deleteQualificationDialog.body')}
      getRowId={(row) => row.id}
      canBeEditedProp="canBeEdited"
    />
  );
};

export default Qualifications;
